import { Col, Image, Row } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMapPin } from "react-icons/fi"; 
import apiClient from "../../Actions/apiClient";
import AssetPath from "../../AssetPath/AssetPath";
import ButtonBox from "../../Components/ButtonBox/ButtonBox";
import PageTitle from "../../Components/PageTitle/PageTitle";
import { sanitizeHTML } from "../../Util/Util";
import "./EventandRegistration.scss";

export default function PastEvents() {
  const [dataSource, setDataSource] = useState([]);
  const navigate = useNavigate(); 

  useEffect(() => {
    apiClient.get("events/list").then(({ data }) => {
      if (data && data.result) {
        const sortedData = data.result.sort(
          (a, b) => new Date(b.eventDateStart) - new Date(a.eventDateStart)
        );

        setDataSource(sortedData);
      }
    });
  }, []);

  const handleViewDetails = (eventId) => {
    navigate(`/event-details/${eventId}`);
  };

  const renderEventsSection = (title, events) => (
    <section className="spacing bg-white">
      <div className="container">
        <div className="text-center mb-3">
          <h4 className="title text-primary fw-bold">{title}</h4>
        </div>
        <Row
          gutter={[
            { xs: 10, sm: 16, md: 24, lg: 30 },
            { xs: 10, sm: 16, md: 24, lg: 30 },
          ]}
          justify="center"
          align="middle"
        >
          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 18 }}
            lg={{ span: 18 }}
          >
            <div className="upcoming-events">
              {events.map((eventData, index) => {
                const imageUrl = eventData.thumbnailUrl || AssetPath.placeholderMenImage;

                return (
                  <div
                    className="events-list border card p-0 d-flex flex-column flex-md-row flex-lg-row  mt-3"
                    key={index}
                  >
                    <div className="image position-relative overflow-hidden">
                      <span
                        style={{ left: "30px" }}
                        className="tags font-4 position-absolute bg-primary text-white bottom-0 font-weight-normal"
                      >
                        {eventData.eventDateStart && eventData.eventDateEnd ? (
                          <>
                            {new Date(eventData.eventDateStart).toLocaleDateString(
                              "en-US",
                              {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                              },
                            )}{" "}
                            -{" "}
                            {new Date(eventData.eventDateEnd).toLocaleDateString(
                              "en-US",
                              {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                              },
                            )}
                            {eventData.eventTime ? ` at ${eventData.eventTime}` : ""}
                          </>
                        ) : (
                          eventData.eventDateStart &&
                          new Date(eventData.eventDateStart).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "2-digit",
                            }
                          )
                        )}
                      </span>

                      <Image
                        src={imageUrl}
                        alt={eventData.title}
                        className="w-100"
                        fallback={AssetPath.placeholderMenImage}
                      />
                    </div>
                    <div className="details text-start">
                      <h3 className="text-primary font-1">{eventData.title}</h3>
                      <h4 className="text-black fst-italic font-2">
                        {eventData.subtitle}
                      </h4>
                      <div className="d-none">
                        {eventData.priceinDollar && (
                          <div className="tag me-2">
                            $ {eventData.priceinDollar}
                          </div>
                        )}
                        {eventData.priceinRupees && (
                          <div className="tag">₹ {eventData.priceinRupees}</div>
                        )}
                      </div>
                      <div 
                        className="text-gray font-4 mb-3 mt-2 text-ellipsis3"
                        dangerouslySetInnerHTML={{
                          __html: sanitizeHTML(eventData.shortDescription)
                        }}
                      />
                      <div className="border-top text-gray pt-2">
                        <FiMapPin size={16} className="text-primary me-1" />
                        <span className="font-4">{eventData.location}</span>
                      </div>
                      <div className="buttons-links d-flex align-items-center flex-column flex-md-row flex-lg-row justify-content-start mt-3">
                        {/* {eventData.eventLink1 && (
                          <ButtonBox
                            type="primary"
                            label="More Details"
                            href={eventData.pastEventLink}
                            rightArrowIcon
                          />
                        )} */}
                        <ButtonBox
                          className={eventData.eventLink1 ? "ms-2" : ""}
                          onClick={() =>
                            handleViewDetails(eventData._id || eventData.id)
                          }
                          rightArrowIcon={true}
                        >
                          View Details
                        </ButtonBox>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
  const pastEvents = dataSource
    .filter((data) => data.eventType === "PastEvents")
    .sort((a, b) => new Date(b.eventDateStart) - new Date(a.eventDateStart));

  return (
    <>
      <PageTitle
        mainTitle="Past Events"
        breadcrumbItems={[
          { name: "Past Events", path: "/events-and-registration" },
        ]}
        image={AssetPath.breadcrumb.pastEvents}
      />

      {pastEvents.length > 0 && renderEventsSection("Past Events", pastEvents)}
    </>
  );
}
